import { maybe } from '@passionware/monads';
import { type AppScope, appScopeUtils } from './appScope.types';
import { workspaceRoutesFor } from './useBrowsingWorkspaceRoutes';

/** The contact page in the browsing scope: `/w/{ws}/…` on a workspace URL, the legacy path otherwise. */
export function contactDetailPathInScope(
  scope: AppScope,
  contactId: string | number
): string {
  return workspaceRoutesFor(
    scope.organizationId,
    maybe.getOrUndefined(appScopeUtils.getWorkspaceSlug(scope))
  ).contacts.detail(contactId);
}
